import {IBrandState} from 'modules/brand/types';
import {createContext} from 'react';

export type TBrandListPageContext = Pick<IBrandState, 'brandList' | 'popularBrandList'>;

export const BrandListPageContext = createContext<TBrandListPageContext>({
    brandList: [],
    popularBrandList: [],
} as TBrandListPageContext);
